import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { JssService } from '@app/shared/services/jss.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Density } from './matMixDensity';
import { MatMixService } from '@app/shared/services/mat-mix.service';

@Component({
  selector: 'app-matrial-mix',
  templateUrl: './matrial-mix.component.html',
  styleUrls: ['./matrial-mix.component.css']
})
export class MatrialMixComponent implements OnInit {
  addMaterialForm: FormGroup;
  clientList: any[] = [];
  jobList: any[] = [];
  orderId: string = '';
  Materials: any[] = []; // Array to hold fetched materials
  density = Density;
  ClientName: string = ''; // Property to hold the selected client's name
  JobName: string = '';
  orderQty: string = '';
  poNum: string = '';
  newMaterial: any = {}; // Initialize newMaterial object

  constructor(
    private fb: FormBuilder,
    private jss: JssService, 
    private matMixService: MatMixService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef

  ) {
    this.addMaterialForm = this.fb.group({
      clientName: [''],
      jobName: [''],
      orderQty: [''],
      poNum: [''],
      orderper: [''],
    
      waste: [''],
    //  matRequired: [''],
    //   // Add other form controls as needed
      // exMaterials: this.fb.array([])

    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      const orderId = params['id'];
      this.orderId = orderId;
      if (orderId) {
        // Handle if orderId is present
        this.fetchAllJssbyId(orderId);

      } else {
        console.error('No orderId found in URL parameter.');
      }
    });

    this.getClients();
       // Subscribe to changes in clientName form control to update job list
   this.addMaterialForm.get('clientName').valueChanges.subscribe(clientName => {
    if (clientName) {
      this.updateJobList(clientName);
    }
  });

  // Subscribe to changes in jobName form control to update materials list
  this.addMaterialForm.get('jobName').valueChanges.subscribe(jobName => {
    if (jobName) {
      const clientName = this.addMaterialForm.get('clientName').value;
      this.updateMatList(clientName, jobName);
    }
  });
  }
  
  fetchAllJssbyId(orderId: string): void {
    this.jss.getJssById(orderId).subscribe(
      (data: any) => {
        console.log('Fetched Data:', data); // Log the fetched data
        if (data) {
          this.ClientName = data.clientName;
          this.JobName = data.jobName;
          this.orderQty = data.orderKgs;  // Ensure this is the correct property name
          this.poNum = data.poNo;         // Ensure this is the correct property name
  
          // Update form values
          this.addMaterialForm.patchValue({
            clientName: this.ClientName,
            jobName: this.JobName,
            orderQty: this.orderQty,   // Make sure to patch these values
            poNum: this.poNum           // Make sure to patch these values
          });
  
          this.cdr.detectChanges(); // Ensure change detection
        } else {
          console.error('No data found for orderId:', orderId);
        }
      },
      (error) => {
        console.error('Error fetching entries:', error);
      }
    );
  }
  


  // toggleAddNewRowTemplate() {
  //   // Clone the newMaterial object to ensure each form group has its own instance
  //   const newMaterialCopy = { ...this.newMaterial };
    
  //   // Add newMaterialCopy as a new form control in the FormArray
  //   const newFormGroup = this.createMaterialFormGroup(newMaterialCopy);
  //   this.exMaterials.push(newFormGroup);
  
  //   // Automatically calculate GSM for the newly added material
  //   this.calculateGsmForFormGroup(newFormGroup);
  
  //   // Clear newMaterial for next entry
  //   this.newMaterial = {};
  //     // Trigger change detection after modifying form array
  //     this.cdr.detectChanges();
  // }
  
  
  
  
  // get exMaterials() {
  //   return this.addMaterialForm.get('exMaterials') as FormArray;
  // }

  // createMaterialFormGroup(): FormGroup {
  //   return this.fb.group({
  //     extMat: [''],
  //     density: [''],
  //     avgWastage: [''],
  //     thickness: [''],
  //     gsm: [''],
  //     netRm: [''],
  //     waste: [''],
  //     matRequired: ['']
  //   });
  // }
  // createMaterialFormGroup(materialData: any): FormGroup {
  //   return this.fb.group({
  //     extMat: [''],
  //     density: [materialData.density || ''],
  //     thickness: [materialData.thickness || ''],
  //     width: [materialData.width || ''],
  //     gsm: [materialData.gsm || ''],
  //     netRm: [materialData.netRm || ''],
  //     waste: [materialData.waste || ''],
  //     matRequired: [materialData.matRequired || ''],
  //     calculated: [false] // Add a new flag 'calculated' initialized to false

  //   });
  // }
  
  updateDensityAndWastage(selectedMaterial: string, index: number) {
    const density = this.getDensityForMaterial(selectedMaterial);
    
    // Update the specific form group in exMaterials with the retrieved density
    // const control = this.exMaterials.at(index);
    // control.patchValue({ density: density.toString() });
    // Optionally, calculate and update avgWastage here if needed
      // Trigger change detection after updating form group
      this.cdr.detectChanges()
  }
  
  calculateGsmForFormGroup(formGroup: FormGroup) {
    const thickness = formGroup.get('thickness')?.value;
    const density = formGroup.get('density')?.value;

    if (thickness && density) {
      const gsm = this.calculateGsm(thickness, density);
      formGroup.patchValue({ gsm: gsm.toFixed(2) }); // Update 'gsm' in the form group
      this.calculateGrandTotalGsm(); // Update grand total after updating GSM
     
    }
      // Trigger change detection after updating form group
      this.cdr.detectChanges()
  }
  
  

  getClients() {
    this.jss.getJssList().subscribe(
      (clients: any[]) => {
        // Use a Set to store unique client names
        const clientSet = new Set<string>();
  
        // Iterate through the received clients
        clients.forEach(client => {
          // Check if client name already exists in the Set
          if (!clientSet.has(client.clientName)) {
            // If not, add it to the Set and also to the clientList array
            clientSet.add(client.clientName);
            this.clientList.push(client);
          }
        });
          // Trigger change detection after updating form group
    this.cdr.detectChanges()
      },
      (error) => {
        console.error('Error fetching clients:', error);
      }
    );
  }
  

  
  deleteMaterial(index: number, isExMaterial: boolean) {
    if (isExMaterial) {
     // this.exMaterials.removeAt(index);
    } else {
      this.Materials.splice(index, 1);
    }
    // Optionally perform any cleanup or calculation updates after deletion
    // Trigger change detection after updating form group
    this.cdr.detectChanges()
  }
  

 
  
  updateJobList(clientName: string) {
    this.jss.getJobsForClient(clientName).subscribe(
      (jobs: any[]) => {
        this.jobList = jobs;
        console.log('Fetched jobs:', this.jobList); // Verify if jobs have _id
      },
      (error) => {
        console.error('Error fetching jobs:', error);
      }
    );
  }
  

  
  

  selectedJobId: string = ''; // Add this property to store selected job ID

  onSelectJob(jobName: string) {
    const selectedJob = this.jobList.find(job => job.jobName === jobName);
    if (selectedJob) {
      this.selectedJobId = selectedJob._id; // Save the job ID
      console.log('Selected Job ID:', this.selectedJobId); // Verify job ID assignment
  
      // Update form controls based on selected job
      this.addMaterialForm.patchValue({
        orderQty: selectedJob.orderKgs || '', // Ensure to handle undefined or null values
        poNum: selectedJob.poNo || '' // Ensure to handle undefined or null values
      });
  
      this.updateMatList(this.addMaterialForm.value.clientName, jobName);
    } else {
      console.error('Job not found:', jobName);
    }
  }
  
  updateMatList(clientName: string, jobName: string) {
    this.jss.getMaterialsForClient(clientName, jobName).subscribe(
        (response: any) => {
          console.log(response);
            this.Materials = []; // Clear previous materials

            // Check if materials exist in the response
            if (response.materials && response.materials.length > 0) {
                response.materials.forEach((material: any) => {
                    this.addMaterialWithDensity(
                        material.selectedMaterial,
                        material.thickness,
                        material.width,
                        material.selectedProcess
 // Include selected process if needed
                    );
                });
            } else {
                console.warn('No materials found for the specified client and job name.');
            }

            // Calculate grand total GSM after updating Materials array
            this.calculateGrandTotalGsm();

            console.log('Fetched materials:', this.Materials);
            // Trigger change detection after updating form group
            this.cdr.detectChanges();
        },
        (error) => {
            console.error('Error fetching materials for client:', error);
        }
    );
}


  // updateMatList(clientName: string, jobName: string) {
  //   this.jss.getMaterialsForClient(clientName, jobName).subscribe(
  //     (materials: any) => {
  //       this.Materials = []; // Clear previous materials

  //       if (materials.selectedPrintingMat) {
  //         this.addMaterialWithDensity(materials.selectedPrintingMat, materials.printingMatThickness, materials.printingMatWidth);
  //       }
  //       if (materials.selectedLaminatMat1) {
  //         this.addMaterialWithDensity(materials.selectedLaminatMat1, materials.laminatMat1Thickness, materials.laminatMat1Width);
  //       }
  //       if (materials.selectedLaminatMat2) {
  //         this.addMaterialWithDensity(materials.selectedLaminatMat2, materials.laminatMat2Thickness, materials.laminatMat2Width);
  //       }
  //       if (materials.selectedLaminatMat3) {
  //         this.addMaterialWithDensity(materials.selectedLaminatMat3, materials.laminatMat3Thickness, materials.laminatMat3Width);
  //       }

  //       // Calculate grand total GSM after updating Materials array
  //       this.calculateGrandTotalGsm();

  //       console.log('Fetched materials:', this.Materials);
  //         // Trigger change detection after updating form group
  //   this.cdr.detectChanges()
  //     },
  //     (error) => {
  //       console.error('Error fetching materials for client:', error);
  //     }
  //   );
  // }

  addMaterialWithDensity(materialName: string, thickness: number,width:number,process:string) {
    const densityValue = this.getDensityForMaterial(materialName);
    const gsm = this.calculateGsm(thickness, densityValue);

    const material = {
      material: materialName,
      thickness: thickness,
      width: width,
      process:process,
      density: densityValue,
      gsm: gsm
    };

    this.Materials.push(material);
      // Trigger change detection after updating form group
      this.cdr.detectChanges()

  }

  calculateGsm(thickness: number, density: number): number {
    const gsm = thickness * density;
    return parseFloat(gsm.toFixed(2)); // Convert to number and round to 2 decimal places
  }
  grandTotalGsm: number = 0; // Variable to hold the grand total GSM

  calculateGrandTotalGsm() {
    // Calculate grand total GSM from both Materials and exMaterials
    const totalFromMaterials = this.Materials.reduce((total, material) => total + parseFloat(material.gsm), 0);
    // const totalFromExMaterials = this.exMaterials.controls.reduce((total, formGroup) => {
    //   const gsmValue = parseFloat(formGroup.get('gsm')?.value || '0');
    //   return total + gsmValue;
    // }, 0);

    this.grandTotalGsm = totalFromMaterials;
    //  + totalFromExMaterials;

    console.log('Total GSM of all materials:', this.grandTotalGsm);
  // Trigger change detection after updating form group
  this.cdr.detectChanges()
 
  
  }

  getDensityForMaterial(selectedMaterial: string): number {
    const foundMaterial = this.density.find(item => {
      if (item.Material === selectedMaterial) {
        return true;
      }
      if (item.Variations) {
        return item.Variations.some(variation => variation.Name === selectedMaterial);
      }
      return false;
    });

    if (foundMaterial) {
      if (foundMaterial.Variations && foundMaterial.Variations.length > 0) {
        return foundMaterial.Variations[0].Density;
      } else if (foundMaterial.Density !== undefined) {
        return foundMaterial.Density;
      }
    }

    return 1; // Default density if not found
  }

 

initialOrderper: number; // Initialize initialOrderper
updateOperperValue(): number {
  const orderper = parseFloat(this.addMaterialForm.value.orderper);
  const orderQty = parseFloat(this.addMaterialForm.value.orderQty);
  // Store the initial orderper value
  this.initialOrderper = orderper;
  // Calculate the new value for orderper based on the formula
  const newOrderper = ((orderQty * orderper) / 100) + orderQty;



  // Return the calculated newOrderper value to be used in addMaterial()
  return newOrderper;
}

grandTotalMatReq = 0;
wasteInKg = 0;
calcMatReq(material: any) {
  // Check if already calculated
  if (material.calculated) {
    // If already calculated, recalculate matRequired based on updated waste value
    const orderQty = parseFloat(this.addMaterialForm.value.orderQty);
    const thickness = parseFloat(material.thickness);
    const densityValue = parseFloat(material.density);
    const wastePercentage = parseFloat(material.waste);
    const orderper = this.updateOperperValue();

    const gsm = this.calculateGsm(thickness, densityValue);
    const netRm = (gsm * orderper) / this.grandTotalGsm;
    const newMatRequired = (wastePercentage * netRm / 100) + netRm;

    // Calculate the difference with previous matRequired before updating
    const previousMatReq = parseFloat(material.matRequired);
    const matReqDiff = newMatRequired - previousMatReq;

    // Adjust grandTotalMatReq and wasteInKg based on the difference
    this.grandTotalMatReq -= previousMatReq; // Subtract previous matRequired
    this.grandTotalMatReq += newMatRequired; // Add new matRequired
    this.wasteInKg = this.grandTotalMatReq - orderQty;

    // Update values in the material object
    material.netRm = netRm.toFixed(2);
    material.matRequired = newMatRequired.toFixed(2);

    // Optionally log values for debugging
    console.log("Previous GSM total:", this.grandTotalGsm);
    console.log("Updated grandTotalMatReq total:", this.grandTotalMatReq);
    console.log("Updated wasteInKg total:", this.wasteInKg);
    console.log('Material netRm:', material.netRm);
    console.log('Material matRequired:', material.matRequired);
    console.log("Previous matRequired:", previousMatReq);

    console.log('Material:', material);

    return; // Exit function since recalculation is done
  }

  // Set 'calculated' flag to true after performing calculations
  material.calculated = true;

  // Initial calculation flow for first time calculation
  const orderQty = parseFloat(this.addMaterialForm.value.orderQty);
  const thickness = parseFloat(material.thickness);
  const densityValue = parseFloat(material.density);
  const wastePercentage = parseFloat(material.waste);
  const orderper = this.updateOperperValue();

  const gsm = this.calculateGsm(thickness, densityValue);
  const netRm = (gsm * orderper) / this.grandTotalGsm;
  const matRequired = (wastePercentage * netRm / 100) + netRm;

  // Update values in the material object
  material.netRm = netRm.toFixed(2);
  material.matRequired = matRequired.toFixed(2);

  // Update grandTotalMatReq and wasteInKg
  this.grandTotalMatReq += matRequired;
  this.wasteInKg = this.grandTotalMatReq - orderQty;

  // Optionally log values for debugging
  console.log("Previous GSM total:", this.grandTotalGsm);
  console.log("Updated grandTotalMatReq total:", this.grandTotalMatReq);
  console.log("Updated wasteInKg total:", this.wasteInKg);
  console.log('Material netRm:', material.netRm);
  console.log('Material matRequired:', material.matRequired);

  console.log('Material:', material);
}

  disableSaveBtn(){
    let allRequired = true; 
    this.Materials.forEach((element) => {
        if (!element.matRequired || element.matRequired === 'NaN') {
            allRequired = false; 
            return; 
        }
    });
    return !allRequired;
  }
  saveAndContinue(): void {
    // Check if the form is valid
    if (this.addMaterialForm.invalid) {
      // Optionally, you can display a message to the user
      alert('Please fill out all required fields correctly.');
      return; // If the form is invalid, do not proceed with saving
    }
  
    // Display a confirmation dialog before saving
    if (!confirm('Are you sure you want to save?')) {
      return; // If user cancels, do not proceed with saving
    }
  
    const formData = this.addMaterialForm.value;
    const dataToSave = {
      orderId: this.orderId || this.selectedJobId,
      clientName: formData.clientName,
      jobName: formData.jobName,
      poNum: formData.poNum,
      orderQty: parseFloat(formData.orderQty),
      orderper: parseFloat(formData.orderper),
     // exMaterials: this.exMaterials.controls.map(formGroup => formGroup.value),
      Materials: this.Materials
    };
  
    this.matMixService.createMatMix(dataToSave)
      .subscribe(
        response => {
          console.log('Data saved successfully:', response);
          // Optionally reset form or perform other actions after successful save
  
          // Redirect to the desired route after saving
          this.router.navigate(['/UnsavedOrder']);
          // this.router.navigate(['/matAllot'], { queryParams: { orderId: this.orderId } });
        },
        error => {
          console.error('Error saving data:', error);
          // Handle error scenario
        }
      );
  }
  
  

}
